import React, { useState, useEffect, useRef, useCallback } from 'react'
import BannerImg from "../../assets/images/banner.webp"
import { FiSearch } from "react-icons/fi";
import { apiCallingPost } from '../../api/services';
import { IoCloseOutline } from "react-icons/io5";
import { MdOutlineZoomOutMap } from "react-icons/md";
import ListPopup from './list-show-all-popup';
import Loader from "../../assets/images/loader.gif"
import { useSelector, useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import {
  setFileType,
  setSearchText,
  setOffsetTag,
  setPageSizeTag,
  setSearchMode,
  setShowMoreTag,
  setHasMoreTag,
  setTextTrigger,
  setTagList,
  setTotalCountTag,
  setLoadingTag,
  setSearchType,
  setLocationName,
  setSelectDate,
  setTagNames,
  setTagNameFlag
} from '../../redux/reducers/commonSlice';
import { setSelectedQuality, setCurrentPlaybackRate, setViewType, setVolume, setIsMuted } from '../../redux/reducers/commonSliceWhiteList';

function Banner(props) {
  const dispatch = useDispatch()
  const searchRef = useRef(null);
  const { fileType, searchText, locationName, searchType, selectDate, offsetTag, showMoreTag, tagList,
    pageSizeTag, loadingTag, tagNames } = useSelector((state) => state.commonData)
  const { currentPlaybackRate, volume, isMuted } = useSelector((state) => state.commonDataWhiteList);
  const debounceTimer = useRef(null);
  const videoRefs = useRef({});
  const [showInput, setShowInput] = useState(false)
  const [tagPopupFlag, setTagPopupFlag] = useState(false);
  const [sliceLength, setSliceLength] = useState(3);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const { userData } = useSelector((state) => state.masterData);

  const isMobile = useCallback(() => {
    return window.innerWidth <= 768;
  }, []);

  const [isMobileDevice, setIsMobileDevice] = useState(isMobile());

  const handleClickOutside = useCallback((event) => {
    const bannerSearchDiv = document.querySelector(".banner-search-div");
    if (
      searchRef.current &&
      !searchRef.current.contains(event.target) &&
      bannerSearchDiv &&
      !bannerSearchDiv.contains(event.target)
    ) {
      props.setVideoListFlag?.(false);
    }
  }, []);

  useEffect(() => {
    if (isMobileDevice) {
      setSliceLength(2);
    } else {
      setSliceLength(3);
    }

    const handleResize = () => {
      setIsMobileDevice(isMobile());
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileDevice, handleClickOutside]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        props.setVideoListFlag?.(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (searchText.length >= 3 || locationName.length >= 3 || selectDate || searchType === 1 || searchType === 0) {
      clearTimeout(debounceTimer.current)
      debounceTimer.current = setTimeout(() => {
        searchTag();
      }, 600);
    }
    return () => clearTimeout(debounceTimer.current);
  }, [searchText, fileType, locationName, selectDate, searchType, offsetTag, pageSizeTag])

  useEffect(() => {
    if (showMoreTag) {
      dispatch(setPageSizeTag(30));
    }
  }, [showMoreTag])


  const handleVolumeChange = (e) => {
    dispatch(setVolume(e.target.volume));
    dispatch(setIsMuted(e.target.muted));
  };

  useEffect(() => {
    Object.values(videoRefs.current).forEach(video => {
      if (video) {
        video.volume = volume;
        video.muted = isMuted;
      }
    });
  }, [volume, isMuted]);

  const changeInput = useCallback(() => {
    setShowInput(prev => !prev);
  }, []);

   const searchTag = async() =>{
    dispatch(setLoadingTag("true"));
    try {
      if (!showMoreTag) {
        props.setVideoListFlag?.(true);
      }
      const postData = {
        searchText: searchText,
        fileType: fileType,
        offSet: offsetTag,
        pagesize: pageSizeTag,
        user_id: userData?.roleDisplayName === "User" ? userData?.userId : "",
        videoLocation: locationName,
        videoDate: selectDate ? moment(selectDate).format('YYYY-MM-DD') : "",
        searchType: searchType == 1 ? "" : "video"
      };
      const response = await apiCallingPost("api/common/tagSearch", postData);
      if (response.data.success === "1") {
        let result = response.data.result;
        let totalCount = 0;

        dispatch(setTagNames(result.nameSuggestion || []))

        if (result.matched && result.matched.length > 0) {
          result = result.matched;
          totalCount = response.data.totalCount;
        } else {
          result = result.suggestions || [];
          totalCount = response.data.suggestionCount;
        }

        dispatch(setTotalCountTag(totalCount));
        dispatch(setTagList(result));
        // dispatch({ type: "SET_DATA", payload: result }); 
      } else {
        dispatch(setTagList([]));
        dispatch(setTagNames([]))
      }
    } catch (error) {
      console.error('Search error:', error);
      dispatch(setTagList([]));
      dispatch(setTagNames([]))
    } finally {
      dispatch(setLoadingTag("false"));
    }
  }

  const handleShowMore = useCallback(() => {
    dispatch(setOffsetTag(0));
    dispatch(setShowMoreTag(true));
    props.setVideoListFlag?.(false);
    dispatch(setTextTrigger(prev => !prev));
  }, [dispatch]);

  const popupTagShow = useCallback((data) => {
    setSelectedData(data);
    setTagPopupFlag(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const cancelPopup = useCallback(() => {
    props.setVideoListFlag(false);
    dispatch(setSearchText(""));
    dispatch(setLocationName(""))
    dispatch(setSelectDate(null))
    document.body.style.overflow = 'auto';
  }, []);

  const cancelTagPopup = useCallback(() => {
    setTagPopupFlag(false);
    document.body.style.overflow = 'auto';
  }, []);

  return (
    <div className='banner-wrapper'>
      <div className='banner-img-div'>
        <img
          className='img-fluid banner-img'
          src={BannerImg}
          alt='Banner image'
          width="100%"
          height={500}
        />
      </div>

      <div className='banner-search-wrapper'>
        <div className='container'>
          <h1 className='banner-head'>Unveil the Magic of Qatar</h1>

          <div className='banner-search'>
            <div className='banner-button-wrapper'>
              <button
                className={`banner-button ${fileType === "" ? "active" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setFileType(""))
                  dispatch(setOffsetTag(0));
                }}
              >
                All
              </button>
              <button
                className={`banner-button ${fileType == "1" ? "active" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setSearchType(null))
                  dispatch(setFileType("1"))
                  dispatch(setOffsetTag(0));
                }}
              >
                Images
              </button>
              <button
                className={`banner-button ${fileType == "2" ? "active" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setFileType("2"))
                  dispatch(setOffsetTag(0));
                }}
              >
                Videos
              </button>
            </div>

            <div className='col-12 col-md-9 tagNames banner-search-section'>
              <div className='banner-search-div main-search-div' >
                <div className={`position-relative banner-input-div banner-input-full ${showInput ? 'active' : ''}`}>
                  <FiSearch className='banner-search-input-icon' />
                  <input
                    type='text'
                    className='banner-search-input'
                    placeholder='Search'
                    value={searchText}
                    onChange={(e) => {
                      dispatch(setSearchText(e.target.value))
                      dispatch(setTagNameFlag(false));
                      dispatch(setOffsetTag(0));
                    }}
                  />
                </div>

                <div className={`banner-input-div banner-input-change ${showInput ? 'input-size-active' : ''}`}>
                  <input
                    type="text"
                    className='banner-search-input'
                    placeholder='Location'
                    value={locationName}
                    onChange={(e) => {
                      dispatch(setLocationName(e.target.value))
                      dispatch(setOffsetTag(0));
                    }}
                  />
                  {fileType != "1" &&
                    <div className='checkbox-advance'>
                      <label className="custom-checkbox label-class-checkbox">
                        <input type="checkbox"
                          checked={searchType === 1}
                          onChange={(e) => {
                            dispatch(setSearchType(e.target.checked ? 1 : 0))
                            dispatch(setOffsetTag(0));
                          }} />
                        <span className="checkmark"></span>
                      </label>
                      <label className='advance-label'>Search by segment</label>
                    </div>
                  }
                </div>

                <div className={`banner-input-div banner-input-change ${showInput ? 'input-size-active-last' : ''}`}>
                  <DatePicker
                    selected={selectDate}
                    className='banner-search-input'
                    placeholderText="Date"
                    dateFormat="dd-MM-yyyy"
                    onChange={(date) => {
                      dispatch(setSelectDate(date))
                      dispatch(setOffsetTag(0));
                    }}
                    isClearable
                    calendarClassName="custom-calendar"
                    renderCustomHeader={({
                      date,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <div className="custom-header">
                        <div className="custom-header-top">
                          <div className="day">
                            {date.toLocaleDateString("en-US", {
                              weekday: "short",
                              month: "short",
                              day: "numeric",
                            })}
                          </div>
                        </div>
                        <div className="custom-month-nav">

                          <span className="month-year">
                            {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
                          </span>
                          <div>
                            <span onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn-picker">
                              <MdKeyboardArrowLeft color="#fff" size={25} />
                            </span>
                            <span onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn-picker">
                              <MdOutlineKeyboardArrowRight color="#fff" size={25} />
                            </span>
                          </div>

                        </div>
                      </div>
                    )} />
                </div>

                {props.videoListFlag && (
                  <span className="closeBtn-search">
                    <IoCloseOutline size={32} onClick={cancelPopup} />
                  </span>
                )}

                <div className='advance-search-div' onClick={changeInput}>
                  Advanced search
                </div>
              </div>

              {props.videoListFlag && (
                <div className={`banner-search-list ${props.videoListFlag ? '' : 'd-none'}`} ref={searchRef}>
                  {tagNames.length > 0 && (
                    <div className='col-md-12'>
                      <p className='banner-search-text text-start mb-0'>
                        Did you mean:
                        {tagNames.map((name, i) => (
                          <span
                            className='f-medium banner-search-text-span'
                            key={i}
                            onClick={() => {
                              dispatch(setSearchText(name))
                              dispatch(setShowMoreTag(true));
                              dispatch(setTagNameFlag(true));
                              props.setVideoListFlag?.(false);
                            }}
                          >
                            {name}
                          </span>
                        ))}
                      </p>
                    </div>
                  )}

                  <div className="banner-search-sublist">
                    {tagList?.length > 0 ? (
                      tagList.slice(0, sliceLength).map((data, i) => (
                        <div className='col-md-4' key={data.id || i}>
                          <div
                            className="card"
                          // onMouseEnter={() => handleVideoMouseEnter(data)}
                          // onMouseLeave={() => handleVideoMouseLeave(data.id)}
                          >
                            {data.file_type_id == "2" ? (
                              <video
                                key={data.url}
                                poster={data?.thumbnail_image}
                                muted
                                controlsList="nodownload"
                                // onContextMenu={(event) => event.preventDefault()}
                                // onPlay={handleVideoPlay}
                                onPlay={() => {
                                  if (!props.isAuthenticated) {
                                    window.location.href = "/login";
                                  }
                                }}
                                controls
                                // onTimeUpdate={(e) => handleVideoTimeUpdate(e, data)}
                                // onLoadedMetadata={(e) => handleVideoLoadedMetadata(e, data)}

                                ref={(el) => {
                                  videoRefs.current[data.video_id] = el;
                                  if (el) {
                                    el.playbackRate = currentPlaybackRate;
                                    el.volume = (typeof volume === 'number' && !isNaN(volume) ? Math.min(Math.max(volume, 0), 1) : 1);
                                    el.muted = isMuted;
                                  }
                                }}
                                onVolumeChange={handleVolumeChange}
                                onMouseEnter={() => {
                                  const videoEl = videoRefs.current[data.video_id];
                                  if (videoEl) {
                                    videoEl.play().catch((err) =>
                                      console.warn("Autoplay failed:", err.message)
                                    );
                                  }
                                }}
                                onMouseLeave={() => {
                                  const videoEl = videoRefs.current[data.video_id];
                                  if (videoEl) {
                                    videoEl.pause();
                                    // videoEl.currentTime = 0; 
                                  }
                                }}
                                className="banner-search-tag"
                              >
                                <source
                                  src={
                                    isFullScreen
                                      ? data?.video_variants?.find((item) => item.quality_type == '1080')?.name || data?.url
                                      : data?.video_variants?.find((item) => item.quality_type == '480')?.name || data?.url
                                  }
                                  type="video/mp4"
                                />
                                Your browser does not support HTML5 video.
                              </video>
                            ) : (
                              <div className='img-outer position-relative image-container'>
                                <img
                                  src={data.url}
                                  className="banner-search-tag"
                                  alt="search result"
                                  width={100}
                                  height={100}
                                  onContextMenu={(event) => event.preventDefault()}
                                  onClick={() => popupTagShow(data)}
                                />
                                {sliceLength !== i + 1 && (
                                  <MdOutlineZoomOutMap
                                    className='img-zoom'
                                    onClick={() => popupTagShow(data)}
                                  />
                                )}
                              </div>
                            )}

                            {sliceLength !== i + 1 ? (
                              <div className="card-body">
                                <h5 className="card-title" title={data.video_heading}>
                                  {data.video_heading}
                                </h5>
                              </div>
                            ) : (
                              (isMobileDevice ? sliceLength === 2 : sliceLength === 3) && (
                                <div className="card-body card-show-more" onClick={handleShowMore}>
                                  <span className="card-title">Show More</span>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      (loadingTag == "false") && (
                        <div className='col-md-4'>
                          <p>No data found</p>
                        </div>
                      )
                    )}

                    {(loadingTag == "true") && (
                      <div className="d-flex flex-column text-center">
                        <div>
                          <img
                            src={Loader}
                            alt="Loading..."
                            className="img-fluid"
                            width="100"
                            height="100"
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='col-md-12 mt-0'>
                    <hr className='theme-color mt-0' />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {tagPopupFlag && (
        <ListPopup
          cancelPopup={cancelTagPopup}
          userData={props.userData}
          isAuthenticated={props.isAuthenticated}
          selectedData={selectedData}
        />
      )}
    </div>
  );
}

// export default Banner;
export default Banner;
